const demoData = [
  [0, 0, 0],
  [6.35156, 2.375, 1.11719],
  [5.15625, 2.49219, 1.03906],
  [4.17969, 2.24219, 0.74219],
  [5.36719, 1.83594, 1.14063],
  [4.14063, 1.84375, 1.13281],
  [4.08594, 0.5625, 1.16406],
  [2.26563, 2.21875, 1.07813],
  [4.53906, 1.92188, 0.92969],
  [4.32813, 1.58594, 0.70313],
  [3.53125, 3.1875, 0.98438],
  [3.35938, 2.44531, 0.64063],
  [2.39844, 2.55469, 1.28125],
  [4.84375, 2.01563, 1.46094],
  [5.22656, 2.0625, 0.90625],
  [2.26563, 2.13281, 1.22656],
  [3.92188, 2.10156, 0.89063],
  [3.28906, 2.27344, 1.375],
  [4.60156, 2.13281, 1.14063],
  [4.15625, 3.25, 1.45313],
  [4.21875, 2.00781, 0.83594],
  [3.57031, 2.27344, 1.26563],
  [5.60156, 2.39063, 1.07813],
  [3.39063, 1.76563, 0.9375],
  [5.17969, 2.38281, 1.21875],
  [4, 2.07813, 1.24219],
  [3.22656, 1.85938, 1.19531],
  [3.20313, 2.35156, 0.89844],
  [4.75, 3.33594, 0.92188],
  [5.46094, 2.19531, 1.27344],
  [4.32031, 1.94531, 1.04688],
  [4.98438, 1.74219, 1.07031],
  [2.64063, 1.61719, 1.30469],
  [4.51563, 1.13281, 0.91406],
  [4.11719, 2.09375, 0.95313],
  [3.53906, 1.57813, 0.88281],
  [6.29688, 1.78125, 1.11719],
  [4.17188, 3.0625, 0.97656],
  [4.08594, 1.64063, 1.08594],
  [3.54688, 1.42969, 0.96875],
  [2.61719, 1.82031, 0.64063],
  [6.03906, 2.33594, 1.39063],
  [3.92969, 1.71875, 1.09375],
  [6.28125, 1.27344, 1.41406],
  [5.79688, 1.38281, 1.09375],
  [7.25, 3.23438, 0.96094],
  [1.078125, 1.52344, 0.82031],
  [3.99219, 2.10156, 0.71094],
  [2.88281, 2.15625, 1.11719],
  [3.75, 1.67969, 0.97656],
  [3.88281, 1.20313, 0.95313],
  [1.034375, 1.79688, 0.79688],
  [5.14063, 1.82813, 0.85938],
  [4.66406, 2.19531, 1.21875],
  [4.66406, 2.19531, 1.21875],
  [4.63281, 2.15625, 1.32813],
  [4.63281, 2.15625, 1.32813],
  [4.64844, 1.97656, 1.02344],
  [4.64844, 1.97656, 1.02344],
  [5.35938, 2.41406, 1.26563],
  [5.35938, 2.41406, 1.26563],
  [5.60156, 2.57813, 1.01563],
  [5.60156, 2.57813, 1.01563],
  [3.38281, 1.16406, 1.14063],
  [3.38281, 1.16406, 1.14063],
  [4.27344, 1.60156, 1.00781],
  [4.27344, 1.60156, 1.00781],
  [4.51563, 2.02344, 0.98438],
  [4.51563, 2.02344, 0.98438],
  [5.36719, 1.69531, 0.94531],
  [5.36719, 1.69531, 0.94531],
  [5.10156, 1.82031, 1.08594],
  [5.10156, 1.82031, 1.08594],
  [5.46875, 2.89063, 0.95313],
  [5.46875, 2.89063, 0.95313],
  [3.05, 1.42188, 0.71094],
  [3.05, 1.42188, 0.71094],
  [4.99219, 1.96875, 1.39063],
  [4.99219, 1.96875, 1.39063],
  [5.98438, 1.75781, 1.46875],
  [5.98438, 1.75781, 1.46875],
  [6.0625, 3.46094, 1.27344],
  [6.0625, 3.46094, 1.27344],
  [3.03125, 2.21875, 1.14063],
  [3.03125, 2.21875, 1.14063],
  [4.28125, 1.53906, 0.94531],
  [4.28125, 1.53906, 0.94531],
  [4.32031, 2.24219, 0.99219],
  [4.32031, 2.24219, 0.99219],
  [5.84375, 2.08594, 1.375],
  [5.84375, 2.08594, 1.375],
  [6.97656, 1.88281, 1.03125],
  [6.97656, 1.88281, 1.03125],
  [3.67188, 1.92969, 1.13281],
  [3.67188, 1.92969, 1.13281],
  [3.96094, 2.32031, 1.32813],
  [3.96094, 2.32031, 1.32813],
  [3.05469, 2.50781, 0.88281],
  [3.05469, 2.50781, 0.88281],
  [6.07031, 1.77344, 1.35938],
  [6.07031, 1.77344, 1.35938],
  [5.32813, 1.92188, 1.07031],
  [5.32813, 1.92188, 1.07031],
  [3.13281, 2.80469, 1.46875],
  [3.13281, 2.80469, 1.46875],
  [4.64844, 1.10938, 1.32031],
  [4.64844, 1.10938, 1.32031],
  [3.78125, 1.41406, 1.14063],
  [3.78125, 1.41406, 1.14063],
  [8.20313, 2.25, 1.50781],
  [8.20313, 2.25, 1.50781],
  [5.40625, 4.42969, 1.79688],
  [5.40625, 4.42969, 1.79688],
  [2.55469, 3.57813, 1.50781],
  [2.55469, 3.57813, 1.50781],
  [4.47656, 1.67188, 1.07031],
  [4.47656, 1.67188, 1.07031],
  [8.46875, 2.05469, 1.51563],
  [8.46875, 2.05469, 1.51563],
  [3.67188, 2.00781, 1.49219],
  [3.67188, 2.00781, 1.49219],
  [3.375, 2.25781, 1.21094],
  [3.375, 2.25781, 1.21094],
  [3.02344, 2.49219, 0.79688],
  [3.02344, 2.49219, 0.79688],
  [6.73438, 1.63281, 1.15625],
  [6.73438, 1.63281, 1.15625],
  [7.83594, 2.11719, 1.23438],
  [7.83594, 2.11719, 1.23438],
  [3.46094, 1.63281, 1.33594],
  [3.46094, 1.63281, 1.33594],
  [5.625, 2.67188, 1.30469],
  [5.625, 2.67188, 1.30469],
  [6.19531, 2.60938, 1.25],
  [6.19531, 2.60938, 1.25],
  [3.95313, 1.92188, 1.0625],
  [3.95313, 1.92188, 1.0625],
  [4.58594, 1.41406, 1.10938],
  [4.58594, 1.41406, 1.10938],
  [5.57031, 1.77344, 1.59375],
  [5.57031, 1.77344, 1.59375],
  [4.70313, 1.92188, 1.32031],
  [4.70313, 1.92188, 1.32031],
  [3.85156, 1.88281, 1.10156],
  [3.85156, 1.88281, 1.10156],
  [3.14063, 2.34375, 1.39844],
  [3.14063, 2.34375, 1.39844],
  [2.34375, 2.625, 0.92969],
  [2.34375, 2.625, 0.92969],
  [3.61719, 2.13281, 0.78125],
  [3.61719, 2.13281, 0.78125],
  [7.10938, 1.90625, 0.77344],
  [7.10938, 1.90625, 0.77344],
  [4.59375, 2.02344, 1.17188],
  [4.59375, 2.02344, 1.17188],
  [5.72656, 2.39844, 0.95313],
  [5.72656, 2.39844, 0.95313],
  [2.35156, 2.07031, 1.39844],
  [2.35156, 2.07031, 1.39844],
  [2.92188, 1.54688, 0.77344],
  [2.92188, 1.54688, 0.77344],
  [5.30469, 2.10156, 1.41406],
  [5.30469, 2.10156, 1.41406],
  [4.91406, 1.86719, 1.40625],
  [4.91406, 1.86719, 1.40625],
  [4.71094, 2.91406, 0.75781],
  [4.71094, 2.91406, 0.75781],
  [4.11719, 1.61719, 1.08594],
  [4.11719, 1.61719, 1.08594],
  [4.34375, 1.85938, 1.46094],
  [4.34375, 1.85938, 1.46094],
  [3.60156, 1.57031, 0.78125],
  [3.60156, 1.57031, 0.78125],
  [4.48438, 2.19531, 0.96875],
  [4.48438, 2.19531, 0.96875],
  [3.59375, 1.28125, 1.10156],
  [3.59375, 1.28125, 1.10156],
  [3.32031, 1.55469, 0.94531],
  [3.32031, 1.55469, 0.94531],
  [7.88281, 1.42969, 1.11719],
  [7.88281, 1.42969, 1.11719],
  [4.95313, 2.25781, 1.53906],
  [4.95313, 2.25781, 1.53906],
  [5.60156, 1.16406, 1.46875],
  [5.60156, 1.16406, 1.46875],
  [4.66406, 1.625, 1.57031],
  [4.66406, 1.625, 1.57031],
  [3.88281, 2.00781, 1.10156],
  [3.88281, 2.00781, 1.10156],
  [5.71094, 0.75, 1.26563],
  [5.71094, 0.75, 1.26563],
  [5.90625, 1.30469, 1.90625],
  [5.90625, 1.30469, 1.90625],
  [4.00781, 1.25781, 1.03906],
  [4.00781, 1.25781, 1.03906],
  [7.40625, 2.17188, 0.90625],
  [7.40625, 2.17188, 0.90625],
  [6.125, 1.10938, 1.04688],
  [6.125, 1.10938, 1.04688],
  [8, 2.26563, 1.13281],
  [8, 2.26563, 1.13281],
  [5.01563, 1.83594, 0.90625],
  [5.01563, 1.83594, 0.90625],
  [4.95313, 2.44531, 1.17969],
  [4.95313, 2.44531, 1.17969],
  [3.875, 1.78906, 0.78906],
  [3.875, 1.78906, 0.78906],
  [5.82031, 1.25, 1.22656],
  [5.82031, 1.25, 1.22656],
  [2.91406, 1.82813, 1.36719],
  [2.91406, 1.82813, 1.36719],
  [3.36719, 2.19531, 1.19531],
  [3.36719, 2.19531, 1.19531],
  [6.09375, 2.28906, 1.14844],
  [6.09375, 2.28906, 1.14844],
  [5.03906, 2.10938, 1.28906],
  [5.03906, 2.10938, 1.28906],
  [4.61719, 1.94531, 1.60156],
  [4.61719, 1.94531, 1.60156],
  [4.41406, 2.65625, 0.84375],
  [4.41406, 2.65625, 0.84375],
  [4.0625, 2.11719, 0.875],
  [4.0625, 2.11719, 0.875],
  [4.70313, 1.71094, 1.03125],
  [4.70313, 1.71094, 1.03125],
  [3.34375, 1.42969, 1.53906],
  [3.34375, 1.42969, 1.53906],
  [2.25, 1.48438, 0.84375],
  [2.25, 1.48438, 0.84375],
  [2.85156, 1.89063, 1.39063],
  [2.85156, 1.89063, 1.39063],
  [7.32031, 1.32813, 1.75],
  [7.32031, 1.32813, 1.75],
  [2.42188, 1.32813, 1.52344],
  [2.42188, 1.32813, 1.52344],
  [7.52344, 1.22656, 1.14063],
  [7.52344, 1.22656, 1.14063],
  [1.058125, 2.13281, 1.0625],
  [1.058125, 2.13281, 1.0625],
  [3.99219, 2.59375, 1.09375],
  [3.99219, 2.59375, 1.09375],
  [3.76563, 1.84375, 1.22656],
  [3.76563, 1.84375, 1.22656],
  [4.09375, 2.69531, 1.16406],
  [4.09375, 2.69531, 1.16406],
  [4.89844, 1.45313, 1.41406],
  [4.89844, 1.45313, 1.41406],
  [4.20313, 1.96875, 1.02344],
  [4.20313, 1.96875, 1.02344],
  [2.67188, 1.30469, 0.96875],
  [2.67188, 1.30469, 0.96875],
  [4.14063, 3.17969, 1.47656],
  [4.14063, 3.17969, 1.47656],
  [5.16406, 2.83594, 0.89844],
  [5.16406, 2.83594, 0.89844],
  [5, 1.59375, 1.32031],
  [5, 1.59375, 1.32031],
  [4.86719, 1.67188, 0.92188],
  [4.86719, 1.67188, 0.92188],
  [5.82813, 2.07813, 1.10156],
  [5.82813, 2.07813, 1.10156],
  [2.39063, 1.67188, 1.35156],
  [2.39063, 1.67188, 1.35156],
  [4.80469, 2.80469, 1.10938],
  [4.80469, 2.80469, 1.10938],
  [3.26563, 2.25, 1.25781],
  [3.26563, 2.25, 1.25781],
  [4.70313, 2.03906, 1.14063],
  [4.70313, 2.03906, 1.14063],
  [3.13281, 1.67188, 1.67188],
  [3.13281, 1.67188, 1.67188],
  [1.033125, 1.39063, 1.41406],
  [1.033125, 1.39063, 1.41406],
  [6.60156, 1.82813, 0.94531],
  [6.60156, 1.82813, 0.94531],
  [5.35938, 2.14844, 1.52344],
  [5.35938, 2.14844, 1.52344],
  [1.038125, 1.35156, 1.26563],
  [1.038125, 1.35156, 1.26563],
  [5.96875, 2.13281, 1.07031],
  [5.96875, 2.13281, 1.07031],
  [3.74219, 2.42969, 1.19531],
  [3.74219, 2.42969, 1.19531],
  [3.82813, 1.40625, 1.10938],
  [3.82813, 1.40625, 1.10938],
  [8.13281, 2.21875, 1.75],
  [8.13281, 2.21875, 1.75],
  [3.78906, 2.73438, 1.74219],
  [3.78906, 2.73438, 1.74219],
  [5.71094, 2.70313, 4.21094],
  [5.71094, 2.70313, 4.21094],
  [4.74219, 1.66406, 1.86719],
  [4.74219, 1.66406, 1.86719],
  [4.03906, 1.17969, 0.9375],
  [4.03906, 1.17969, 0.9375],
  [6.14844, 1.07813, 0.96094],
  [6.14844, 1.07813, 0.96094],
  [4.50781, 2.00781, 1.25],
  [4.50781, 2.00781, 1.25],
  [4.375, 1.83594, 1.13281],
  [4.375, 1.83594, 1.13281],
  [3.85156, 1.45313, 1.01563],
  [3.85156, 1.45313, 1.01563],
  [4.89063, 2.17188, 0.89844],
  [4.89063, 2.17188, 0.89844],
  [4.14844, 1.83594, 0.82031],
  [4.14844, 1.83594, 0.82031],
  [7.10156, 2.41406, 1.40625],
  [7.10156, 2.41406, 1.40625],
  [4.54688, 2.10156, 1.10156],
  [4.54688, 2.10156, 1.10156],
  [5.08594, 1.41406, 1.22656],
  [5.08594, 1.41406, 1.22656],
  [5.11719, 1.80469, 1.08594],
  [5.11719, 1.80469, 1.08594],
  [5.20313, 2.125, 0.96875],
  [5.20313, 2.125, 0.96875],
  [4.70313, 2.10156, 1.32813],
  [4.70313, 2.10156, 1.32813],
  [5.72656, 1.875, 0.8125],
  [5.72656, 1.875, 0.8125],
  [4.72656, 1.80469, 1.08594],
  [4.72656, 1.80469, 1.08594],
  [4.17969, 1.1875, 1.15625],
  [4.17969, 1.1875, 1.15625],
  [4.40625, 1.45313, 0.95313],
  [4.40625, 1.45313, 0.95313],
  [3.89844, 2.79688, 0.96875],
  [3.89844, 2.79688, 0.96875],
  [4.22656, 2.42969, 1.42969],
  [4.22656, 2.42969, 1.42969],
  [5.73438, 2.23438, 1.29688],
  [5.73438, 2.23438, 1.29688],
  [5.39844, 1.92969, 1.17188],
  [5.39844, 1.92969, 1.17188],
  [5.89844, 1.42969, 1.60938],
  [5.89844, 1.42969, 1.60938],
  [4.71875, 1.71875, 1.23438],
  [4.71875, 1.71875, 1.23438],
  [4.46875, 1.88281, 1.17969],
  [4.46875, 1.88281, 1.17969],
  [4.33594, 1.70313, 1.55469],
  [4.33594, 1.70313, 1.55469],
  [4.34375, 1.92188, 1.53906],
  [4.34375, 1.92188, 1.53906],
  [4.17969, 2.19531, 0.90625],
  [4.17969, 2.19531, 0.90625],
  [2.71875, 1.89063, 1.14844],
  [2.71875, 1.89063, 1.14844],
  [3.52344, 3.44531, 1.17969],
  [3.52344, 3.44531, 1.17969],
  [3.32813, 1.54688, 1.15625],
  [3.32813, 1.54688, 1.15625],
  [4.67969, 2.60938, 1.16406],
  [4.67969, 2.60938, 1.16406],
  [5.10156, 2.0625, 1.05469],
  [5.10156, 2.0625, 1.05469],
  [4.03906, 2.54688, 1.17969],
  [4.03906, 2.54688, 1.17969],
  [4.01563, 1.57813, 1.25],
  [4.01563, 1.57813, 1.25],
  [4.42969, 2, 1.10156],
  [4.42969, 2, 1.10156],
  [5.13281, 2.30469, 1.26563],
  [5.13281, 2.30469, 1.26563],
  [4.19531, 1.97656, 1.55469],
  [4.19531, 1.97656, 1.55469],
  [5.76563, 2.10938, 1.57031],
  [5.76563, 2.10938, 1.57031],
  [6.00781, 2.21094, 1.27344],
  [6.00781, 2.21094, 1.27344],
  [5.60938, 2.13281, 1.02344],
  [5.60938, 2.13281, 1.02344],
  [4.98438, 2.84375, 1.42188],
  [4.98438, 2.84375, 1.42188],
  [2.92969, 2.05469, 1.10938],
  [2.92969, 2.05469, 1.10938],
  [4.96875, 1.67188, 1.40625],
  [4.96875, 1.67188, 1.40625],
  [4.60156, 1.85156, 1.08594],
  [4.60156, 1.85156, 1.08594],
  [5.07813, 2.86719, 1.17188],
  [5.07813, 2.86719, 1.17188],
  [5.32813, 1.92969, 0.86719],
  [5.32813, 1.92969, 0.86719],
  [3.99219, 1.82813, 1.26563],
  [3.99219, 1.82813, 1.26563],
  [1.625, 1.75781, 0.95313],
  [1.625, 1.75781, 0.95313],
  [4.60156, 2.48438, 1.27344],
  [4.60156, 2.48438, 1.27344],
  [1.048125, 1.875, 0.98438],
  [1.048125, 1.875, 0.98438],
  [1.044375, 2.05469, 1.07813],
  [1.044375, 2.05469, 1.07813],
  [7.15625, 1.57813, 1.64063],
  [7.15625, 1.57813, 1.64063],
  [2.67188, 2.49219, 1.51563],
  [2.67188, 2.49219, 1.51563],
  [2.80469, 2.30469, 1.11719],
  [2.80469, 2.30469, 1.11719],
  [5.99219, 1.64844, 1.76563],
  [5.99219, 1.64844, 1.76563],
  [5.03125, 1.77344, 1.14063],
  [5.03125, 1.77344, 1.14063],
  [1.046875, 2.14844, 1.1875],
  [1.046875, 2.14844, 1.1875],
  [3.24219, 1.875, 1.08594],
  [3.24219, 1.875, 1.08594],
  [7.03906, 2.71094, 1.61719],
  [7.03906, 2.71094, 1.61719],
  [5.35938, 2.55469, 0.875],
  [5.35938, 2.55469, 0.875],
  [4.875, 1.78906, 1.14844],
  [4.875, 1.78906, 1.14844],
  [5.14844, 1.17188, 1.25781],
  [5.14844, 1.17188, 1.25781],
  [3.97656, 1.64844, 1.07031],
  [3.97656, 1.64844, 1.07031],
  [4.54688, 1.35156, 0.84375],
  [4.54688, 1.35156, 0.84375],
  [4.71094, 0.74219, 0.99219],
  [4.71094, 0.74219, 0.99219],
  [6.03906, 1.95313, 0.8125],
  [6.03906, 1.95313, 0.8125],
  [4.48438, 1.25, 1.07031],
  [4.48438, 1.25, 1.07031],
  [2.07813, 2.85938, 1.24219],
  [2.07813, 2.85938, 1.24219],
  [5.51563, 1.83594, 0.96875],
  [5.51563, 1.83594, 0.96875],
  [3.375, 2.82031, 1.21875],
  [3.375, 2.82031, 1.21875],
  [4.64844, 2.30469, 0.88281],
  [4.64844, 2.30469, 0.88281],
  [4.24219, 1.92969, 0.88281],
  [4.24219, 1.92969, 0.88281],
  [2.21875, 1.26563, 0.78906],
  [2.21875, 1.26563, 0.78906],
  [5.23438, 1.92188, 1.58594],
  [5.23438, 1.92188, 1.58594],
  [3.97656, 1.76563, 1.40625],
  [3.97656, 1.76563, 1.40625],
  [2.46094, 1.88281, 1.28125],
  [2.46094, 1.88281, 1.28125],
  [3.14844, 1.44531, 1.32031],
  [3.14844, 1.44531, 1.32031],
  [2.625, 1.09375, 1.32031],
  [2.625, 1.09375, 1.32031],
  [6.41406, 3.125, 1.27344],
  [6.41406, 3.125, 1.27344],
  [4.50781, 3.00781, 1.03906],
  [4.50781, 3.00781, 1.03906],
  [4.875, 2.67969, 1.74219],
  [4.875, 2.67969, 1.74219],
  [4.09375, 3.21875, 1.17188],
  [4.09375, 3.21875, 1.17188],
  [4.36719, 2.45313, 1.11719],
  [4.36719, 2.45313, 1.11719],
  [5.25, 1.80469, 1.38281],
  [5.25, 1.80469, 1.38281],
  [2.14844, 2.77344, 1.35938],
  [2.14844, 2.77344, 1.35938],
  [2.85156, 2.40625, 1.29688],
  [2.85156, 2.40625, 1.29688],
  [3.76563, 1.85156, 1.34375],
  [3.76563, 1.85156, 1.34375],
  [4.09375, 0.78125, 1.36719],
  [4.09375, 0.78125, 1.36719],
  [5.13281, 1.75, 1.69531],
  [5.13281, 1.75, 1.69531],
  [5.58594, 2.23438, 1.38281],
  [5.58594, 2.23438, 1.38281],
  [4.0625, 1.74219, 0.82813],
  [4.0625, 1.74219, 0.82813],
  [5.0625, 2.55469, 1.1875],
  [5.0625, 2.55469, 1.1875],
  [6.36719, 2.10938, 0.86719],
  [6.36719, 2.10938, 0.86719],
  [2.80469, 1.84375, 1.09375],
  [2.80469, 1.84375, 1.09375],
  [3.64063, 1.96094, 1.1875],
  [3.64063, 1.96094, 1.1875],
  [5.63281, 2.40625, 1.04688],
  [5.63281, 2.40625, 1.04688],
  [6.99219, 0.96094, 1.17969],
  [6.99219, 0.96094, 1.17969],
  [4.03125, 0.91406, 0.875],
  [4.03125, 0.91406, 0.875],
  [6.14063, 2.42969, 1.11719],
  [6.14063, 2.42969, 1.11719],
  [5.60938, 2.38281, 1.26563],
  [5.60938, 2.38281, 1.26563],
  [3.40625, 1.78906, 0.78906],
  [3.40625, 1.78906, 0.78906],
  [3.98438, 1.64844, 1.07031],
  [3.98438, 1.64844, 1.07031],
  [3.19531, 1.64844, 0.94531],
  [3.19531, 1.64844, 0.94531],
  [3.60938, 2.50781, 1.28125],
  [3.60938, 2.50781, 1.28125],
  [6.82031, 3.51563, 1.53906],
  [6.82031, 3.51563, 1.53906],
];
export default demoData;
